<template>
  <div>
    <vx-card title="" :is-filter="true" :has-quick-search="true" class="mb-8" :init-collapsed="true" :collapse-action="true" @keyup.enter="loadConsultationData(1, null,false, true)">

      <template slot="actions">
        <vx-input-group>
          <vs-input :placeholder="$t('search_company_name_phone_number')" class="quick-search" v-model="consultationsSearchParams.quickSearch"/>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="primary" type="filled" icon-pack="feather" icon="icon-search"  @click="loadConsultationData(1, null, false, true)"></vs-button>
            </div>
          </template>
        </vx-input-group>&nbsp;
        <vs-button color="success" type="filled" icon-pack="feather" icon="icon-download" @click="exportData">{{ $t('export') }}</vs-button>
      </template>
      <div class="vx-row">
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="consultationsSearchParams.from" :model="consultationsSearchParams.from" :placeholder="$t('date_filter_from')" class="mb-3"></date-picker>
          <vs-input :placeholder="$tc('subject')" v-model="consultationsSearchParams.subject" class="w-full mb-3"/>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
          <date-picker v-model="consultationsSearchParams.to" :model="consultationsSearchParams.to" :placeholder="$t('date_filter_to')" class="mb-3"></date-picker>
<!--          <v-select :options="groupOptions" :reduce="label => label.value" :placeholder="$t('groups')" v-model="consultationsSearchParams.group" class="mb-3" />-->
          <select v-model="consultationsSearchParams.group" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('groups') }}</option>
            <option v-for="(option, key) in groupOptions" :key="'groups_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
<!--          <v-select :options="bigOptions" :reduce="label => label.value" :placeholder="$t('big')" v-model="consultationsSearchParams.big" class="mb-3" />-->
          <select v-model="consultationsSearchParams.big" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('big') }}</option>
            <option v-for="(option, key) in bigOptions" :key="'big_' + key" :value="option.value">{{ option.label }}</option>
          </select>
<!--          <v-select :options="counselorsOptions" :reduce="label => label.value" :placeholder="$t('counselor')" v-model="consultationsSearchParams.counselor" class="mb-3" />-->
          <select v-model="consultationsSearchParams.counselor" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('counselor') }}</option>
            <option v-for="(option, key) in counselorsOptions" :key="'counselor_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full">
<!--          <v-select :options="smallOptions" :reduce="label => label.value" :placeholder="$t('small')" v-model="consultationsSearchParams.small" class="mb-3" />-->
          <select v-model="consultationsSearchParams.small" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('small') }}</option>
            <option v-for="(option, key) in smallOptions" :key="'small_' + key" :value="option.value">{{ option.label }}</option>
          </select>
<!--          <v-select :options="resultOptions" :reduce="label => label.value" :placeholder="$t('result')" v-model="consultationsSearchParams.result" class="mb-3" />-->
          <select v-model="consultationsSearchParams.result" class="vs-inputx vs-input--input normal mb-3" style="width:100%;" >
            <option value="">{{ $t('result') }}</option>
            <option v-for="(option, key) in resultOptions" :key="'result_' + key" :value="option.value">{{ option.label }}</option>
          </select>
        </div>
        <div class="vx-col md:w-1/4 sm:w-1/4 w-full" v-for="(customField, key) in customFields" v-bind:key="'consultationCustomFieldColumn_' + key">
          <select v-model="consultationsSearchParams.consultationCustomFields[customField.id]" class="vs-inputx vs-input--input normal mb-3">
            <option value="" v-text="customField.name"></option>
            <option v-for="(option, key) in customField.active_options" :key="'customFields' + key" :value="option.value">{{ option.value }}</option>
          </select>
<!--          <template v-if="customField.type == 'Text'">-->
<!--            <vs-input v-model="consultationsSearchParams.consultationCustomFields[customField.id]" class="w-full"/>-->
<!--          </template>-->

<!--          <template v-if="customField.type == 'Select'">-->
<!--            <v-select :options="customField.options" :reduce="label => label.value" :placeholder="$t('please_select')" v-model="consultationsSearchParams.consultationCustomFields[customField.id]" class="md:mb-0" />-->
<!--          </template>-->
        </div>
      </div>

      <template slot="footer">
        <vs-button color="success" type="filled" class="w-full" @click.prevent="loadConsultationData(1, null,false, true)" v-text="$t('search')"></vs-button>
      </template>

    </vx-card>

    <vx-card id="consultationDataContainer" :title="$tc('consultation', 2)" class="mb-8 vs-con-loading__container">

      <template slot="actions">
        <shared-consultations-tab-nav></shared-consultations-tab-nav>
      </template>

      <shared-user-consultation-list
        :consultations="consultations"
        :customFields="customFields"
        :activeColumns="activeColumns"
        @callerCompanyPopup="callerCompanyPopup"
        @openOutboundPopup="openOutboundPopup"
        @openEditConsultationPopup="openEditConsultationPopup"
      ></shared-user-consultation-list>

      <template slot="footer">
        <paginate
          :total="consultationPages"
          :itemPerPage="itemPerPage"
          :click-handler="loadConsultationData"
          v-model="initialPage"
          goto
        >
        </paginate>
      </template>

    </vx-card>

    <modal title="" id="callerCompanyModal" :active.sync="modals.viewCallerCompany" size="xl">
      <shared-view-consultation-by-company-name></shared-view-consultation-by-company-name>
    </modal>

    <modal title="" id="outboundConsultation" :active.sync="modals.outbound" size="xl">
      <shared-outbound-consultation @outboundConsultationSuccess="outboundConsultationSuccess"></shared-outbound-consultation>
      <vs-divider></vs-divider>
      <div class="flex justify-end">
        <vs-button color="primary" type="filled" @click="initSaveOutboundConsultationFormData">{{ $t('enrollment') }}</vs-button>
      </div>
    </modal>

    <modal title="" id="editConsultation" :active.sync="modals.editConsultation" size="lg">
      <div id="EditConsultationDataContainer" class="vs-con-loading__container">
        <shared-edit-consultation @editConsultationSuccess="editConsultationSuccess"></shared-edit-consultation>
        <vs-divider></vs-divider>
        <div class="flex justify-end">
          <vs-button id="editConsultationButton" color="primary" type="filled" @click="initSaveConsultationFormData">{{ $t('save') }}</vs-button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import SharedConsultationsTabNav from '@/views/Shared/Consultations/TabNav'
import Consultation from '@/models/Consultation'
import Big from '@/models/Big'
import SharedUserConsultationList from '@/views/Shared/Consultations/Consultations/List'
import Paginate from '@/mixins/paginate'
import Modal from '@/components/Modal'
import Utils from '@/helpers/utils'
import { EventBus } from '@/../eventbus'
import SharedViewConsultationByCompanyName from '@/views/Shared/Consultations/Company/List'
import SharedOutboundConsultation from '@/views/Shared/Consultations/Outbound'
import SharedEditConsultation from '@/views/Shared/Consultations/Consultations/Edit'
import DatePicker from '@/components/form-inputs/DatePicker'

export default {
  name: 'User.Consultations.Consultations',
  mixins: [Paginate],
  components: {
    SharedConsultationsTabNav,
    SharedUserConsultationList,
    Modal,
    SharedViewConsultationByCompanyName,
    SharedOutboundConsultation,
    SharedEditConsultation,
    DatePicker
  },
  data () {
    return {
      activeColumns: {},
      consultations: {},
      consultationPages: 1,
      resultOptions: [],
      customFields: {},
      bigOptions: [],
      smallOptions: [],
      groupOptions: [],
      counselorsOptions: [],
      itemPerPage: null,
      consultationsSearchParams: {
        quickSearch: typeof this.$route.query.quickSearch !== 'undefined' ? this.$route.query.quickSearch : '',
        from: typeof this.$route.query.from !== 'undefined' ? this.$route.query.from : '',
        to: typeof this.$route.query.to !== 'undefined' ? this.$route.query.to : '',
        big: typeof this.$route.query.big !== 'undefined' ? this.$route.query.big : '',
        small: typeof this.$route.query.small !== 'undefined' ? this.$route.query.small : '',
        counselor: typeof this.$route.query.counselor !== 'undefined' ? this.$route.query.counselor : '',
        group: typeof this.$route.query.group !== 'undefined' ? this.$route.query.group : '',
        result: typeof this.$route.query.result !== 'undefined' ? this.$route.query.result : '',
        subject: typeof this.$route.query.subject !== 'undefined' ? this.$route.query.subject : '',
        resultName: typeof this.$route.query.resultName !== 'undefined' ? this.$route.query.resultName : '',
        consultationCustomFields: {},
        memberCustomField: typeof this.$route.query.memberCustomField !== 'undefined' ? this.$route.query.memberCustomField : ''
      },
      consultationExportParams: {},
      companyId: this.$store.getters.userInfo.company.id,
      modals: {
        viewCallerCompany: false,
        outbound: false,
        editConsultation: false
      }
    }
  },
  watch: {
    'consultationsSearchParams.big' (val) {
      this.getSmallList(val)
    }
  },
  mounted () {
    if (typeof this.$route.query.consultationCustomField !== 'undefined' && typeof this.$route.query.consultationCustomFieldValue !== 'undefined') {
      this.consultationsSearchParams.consultationCustomFields[this.$route.query.consultationCustomField] = this.$route.query.consultationCustomFieldValue
    }
    this.loadConsultationData(this.initialPage, null, null, true)
    this.$windowOpenerHelper.listenToPopUpMessage('reload_consultation_callback_member_table', this.reloadConsultationData)
  },
  methods: {
    reloadConsultationData () {
      this.loadConsultationData(this.initialPage, this.itemPerPage)
    },
    async loadConsultationData (page = 1, itemPerPage = null, onload = false, backToPageOne = false) {
      this.$vs.loading({container: '#consultationDataContainer'})

      const searchParams = {}
      searchParams['page'] = page
      if (itemPerPage === null) {
        if (this.itemPerPage !== null) {
          searchParams['itemPerPage'] = this.itemPerPage
        }
      } else {
        this.itemPerPage = itemPerPage
        searchParams['itemPerPage'] = this.itemPerPage
      }
      for (const consultationSearchParam in this.consultationsSearchParams) {
        if (consultationSearchParam === 'consultationCustomFields') {
          for (const consultationCustomFieldId in this.consultationsSearchParams.consultationCustomFields) {
            searchParams[`consultation_custom_field_${consultationCustomFieldId}`] = this.consultationsSearchParams.consultationCustomFields[consultationCustomFieldId]
          }
        } else {
          searchParams[consultationSearchParam] = this.consultationsSearchParams[consultationSearchParam]
        }
      }

      this.$router.replace({ query: searchParams })
      const response = await Consultation.all(searchParams)

      this.customFields = response.data.meta.customFields
      console.log('customFields', this.customFields)
      this.consultations = response.data.data.consultations

      this.activeColumns = response.data.meta.activeColumns
      this.consultationPages = response.data.meta.pagination.last_page
      this.bigOptions = response.data.meta.options.bigs
      this.groupOptions = response.data.meta.options.groups
      this.counselorsOptions = response.data.meta.options.agents
      this.resultOptions = response.data.meta.options.results
      this.itemPerPage = response.data.meta.pagination.per_page

      if (onload === true) {
        if (typeof this.$route.query.big !== 'undefined' && typeof this.$route.query.small !== 'undefined') {
          this.getSmallList(this.$route.query.big)
        }
        // set default value for custom fields
        const parent = this
        this.customFields.forEach(function (item) {
          if (typeof parent.$route.query.consultationCustomField !== 'undefined' && typeof parent.$route.query.consultationCustomFieldValue !== 'undefined') {
            if (item.id === parent.$route.query.consultationCustomField) {
              parent.consultationsSearchParams.consultationCustomFields[item.id] = parent.$route.query.consultationCustomFieldValue
            } else {
              parent.consultationsSearchParams.consultationCustomFields[item.id] = ''
            }
          } else {
            parent.consultationsSearchParams.consultationCustomFields[item.id] = ''
          }
        })
      }

      this.consultationExportParams = searchParams
      if (backToPageOne === true) {
        this.initialPage = 1
      } else {
        this.initialPage = page
      }
      this.$vs.loading.close('#consultationDataContainer > .con-vs-loading')
    },
    async exportData (e) {
      e.preventDefault()
      try {
        const language = this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.language : 'en'
        await Consultation.export({...this.consultationExportParams, companyId: this.companyId, language})
      } catch (e) {
        this.$alertHelper.error()
      }
    },
    callerCompanyModal (companyName) {
      EventBus.$emit('loadConsultationByCompanyName', companyName)
      this.modals.viewCallerCompany = true
    },
    callerCompanyPopup (companyName) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound-company-list', { company_name: companyName }, this.callerCompanyModal)
    },
    outboundConsultationModal (data) {
      EventBus.$emit('initResetOutboundConsultationFormData')
      EventBus.$emit('initLoadOutboundConsultation', { member_id: data.id, callback_id: data.callback_id })
      this.modals.outbound = true
    },
    openOutboundPopup (memberId) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'outbound', { id: memberId }, this.outboundConsultationModal)
    },
    outboundConsultationSuccess (response) {
      this.$swalHelper.success({
        title: this.$t('action_success'),
        text: this.$t(response.data),
        confirmButton: this.$t('confirm')
      })
      this.modals.outbound = false
      this.loadConsultationData(this.initialPage, this.itemPerPage)
    },
    initSaveOutboundConsultationFormData () {
      EventBus.$emit('initSaveOutboundConsultationFormData')
    },
    openEditConsultationPopup (memberId, consultationId) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'edit-consultation', { id: memberId, consultationId }, this.editConsultationModal)
    },
    editConsultationModal (data) {
      EventBus.$emit('initResetEditConsultationFormData')
      EventBus.$emit('initLoadEditConsultation', { id: data.id, consultationId: data.consultationId })
      this.modals.editConsultation = true
    },
    editConsultationSuccess (response) {
      this.$swalHelper.success({
        title: this.$t('action_success'),
        text: this.$t(response.data),
        confirmButton: this.$t('confirm')
      })
      this.modals.editConsultation = false
      this.loadConsultationData(this.initialPage, this.itemPerPage)
    },
    initSaveConsultationFormData () {
      EventBus.$emit('initSaveConsultationFormData')
    },
    async getSmallList (id) {
      try {
        const response = await Big.getSmalls({ id })
        this.smallOptions = []

        for (const small in response.data.smalls) {
          this.smallOptions.push({
            label: response.data.smalls[small],
            value: small
          })
        }

      } catch (e) {
        this.$swalHelper.displayCatchError({
          title: 'Error!',
          errorObject: e,
          confirmButton: this.$t('confirm')
        })
      }
    }
  }
}
</script>

<style scoped>
.quick-search {
  min-width: 300px;
}
</style>
